"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.set");

require("core-js/modules/es6.string.iterator");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _order = require("@/api/cms/order");

var _installTask = require("@/api/cms/installTask");

var _send = require("@/api/cms/send");

var _contract2 = require("@/api/cms/contract");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _index = _interopRequireDefault(require("../orders/orderDetail/index"));

var _index2 = _interopRequireDefault(require("@/views/cms/customers/contractQuotationInfo/index"));

var _index3 = _interopRequireDefault(require("@/views/cms/customers/contractBasicInfo/index"));

var _index4 = _interopRequireDefault(require("@/views/cms/customers/contractDesignInfo/index"));

var _index5 = _interopRequireDefault(require("@/views/cms/customers/contractFollowInfo/index"));

var _index6 = _interopRequireDefault(require("@/views/cms/customers/contractSpecialApply/index"));

var _Dict = _interopRequireDefault(require("@/components/Dict/Dict"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _dictDetail = require("@/api/system/dictDetail");

var _index7 = require("@/utils/index");

var _methods;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var _default = {
  name: 'OrderList',
  components: {
    CommonUpload: _commonUpload.default,
    OrderDetail: _index.default,
    ContractQuotationInfo: _index2.default,
    ContractBasicInfo: _index3.default,
    ContractDesignInfo: _index4.default,
    ContractFollowInfo: _index5.default,
    ContractSpecialApply: _index6.default,
    draggable: _vuedraggable.default
  },
  dicts: ['order_display_fields', 'order_payment_reason', 'order_receiving_account'],
  created: function created() {
    var _this = this;

    this.$on('dictReady', function () {
      _this.initTableHeader();
    });
  },
  computed: {
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.6;
    },
    filteredBomList: function filteredBomList() {
      this.bomSearchVersion;
      var _this$addOrderForm = this.addOrderForm,
          searchCode = _this$addOrderForm.searchCode,
          searchName = _this$addOrderForm.searchName,
          searchColor = _this$addOrderForm.searchColor,
          searchBarCode = _this$addOrderForm.searchBarCode,
          searchMaterialTypeInfo = _this$addOrderForm.searchMaterialTypeInfo,
          searchLength = _this$addOrderForm.searchLength,
          searchWidth = _this$addOrderForm.searchWidth,
          searchHeight = _this$addOrderForm.searchHeight,
          searchQuantity = _this$addOrderForm.searchQuantity,
          searchRemark = _this$addOrderForm.searchRemark,
          bomList = _this$addOrderForm.bomList;
      var code = searchCode ? searchCode.trim() : '';
      var name = searchName ? searchName.trim() : '';
      var color = searchColor ? searchColor.trim() : '';
      var barCode = searchBarCode ? searchBarCode.trim() : '';
      var materialTypeInfo = searchMaterialTypeInfo ? searchMaterialTypeInfo.trim() : '';
      var length = searchLength ? searchLength.trim() : '';
      var width = searchWidth ? searchWidth.trim() : '';
      var height = searchHeight ? searchHeight.trim() : '';
      var quantity = searchQuantity ? searchQuantity.trim() : '';
      var remark = searchRemark ? searchRemark.trim() : '';

      if (!code && !name && !color && !barCode && !materialTypeInfo && !length && !width && !height && !quantity && !remark) {
        return bomList;
      }

      return bomList.filter(function (bom) {
        var matchCode = !code || bom.Code && bom.Code.toLowerCase().includes(code.toLowerCase());
        var matchName = !name || bom.Name && bom.Name.toLowerCase().includes(name.toLowerCase());
        var matchColor = !color || bom.Color && bom.Color.toLowerCase().includes(color.toLowerCase());
        var matchBarCode = !barCode || bom.BarCode && bom.BarCode.toLowerCase().includes(barCode.toLowerCase());
        var matchMaterialTypeInfo = !materialTypeInfo || bom.MaterialTypeInfo && bom.MaterialTypeInfo.toLowerCase().includes(materialTypeInfo.toLowerCase());
        var matchLength = !length || bom.Length !== undefined && String(bom.Length).toLowerCase().includes(length.toLowerCase());
        var matchWidth = !width || bom.Width !== undefined && String(bom.Width).toLowerCase().includes(width.toLowerCase());
        var matchHeight = !height || bom.Height !== undefined && String(bom.Height).toLowerCase().includes(height.toLowerCase());
        var matchQuantity = !quantity || bom.Quantity !== undefined && String(bom.Quantity).toLowerCase().includes(quantity.toLowerCase());
        var matchRemark = !remark || bom.Remark && bom.Remark.toLowerCase().includes(remark.toLowerCase());
        return matchCode && matchName && matchColor && matchBarCode && matchMaterialTypeInfo && matchLength && matchWidth && matchHeight && matchQuantity && matchRemark;
      });
    },
    visibleColumns: {
      get: function get() {
        return this.tableHeader.filter(function (col) {
          return col.visible;
        });
      },
      set: function set(val) {
        this.tableHeader = [].concat((0, _toConsumableArray2.default)(val), (0, _toConsumableArray2.default)(this.tableHeader.filter(function (col) {
          return !col.visible;
        })));
      }
    }
  },
  watch: {
    $route: function $route(to, from) {
      var filter = to.query.filter;

      if (filter) {
        this.searchForm.productionStatus = filter;
      } else {
        this.searchForm.productionStatus = '';
      }

      this.handleSearch();
    },
    tableHeader: {
      handler: function handler() {
        this.$forceUpdate();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    //加载搜索表单
    this.handleSearch(); //加载表头配置

    this.loadHeaderConfig(); //监听屏幕高度变化

    window.addEventListener('resize', this.handleResize);
  },
  activated: function activated() {
    this.handleSearch();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  data: function data() {
    return {
      tableLoading: false,
      exportLoading: false,
      bomTableLoading: false,
      bomSearchVersion: 0,
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      collapsedDesignSchemes: [],
      activeQuotationTab: 'quotation',
      showQuotationDialog: false,
      currentQuotationContract: {},
      // 合同详情相关
      showContractViewDialog: false,
      currentContract: {},
      contractViewImages: [],
      contractViewFiles: [],
      activeContractTab: 'design',
      previewImageVisible: false,
      previewImageUrl: '',
      contractEditable: false,
      // 表头配置相关
      tableHeader: [],
      configDialogVisible: false,
      originalHeaderConfig: [],
      searchForm: {
        productionOrder: '',
        custName: '',
        productionStatus: '',
        custAddress: '',
        contractNo: '',
        scheduledDeliveryDate: ''
      },
      allChecked: false,
      checkedContracts: [],
      checkedDesignSchemes: [],
      checkedOrderSolutions: [],
      // 加急申请相关
      showUrgentApplyDialog: false,
      isEditMode: false,
      urgentApplyForm: {
        title: '',
        custName: '',
        applyDate: '',
        applyReason: '',
        custAddress: '',
        remark: ''
      },
      urgentApplyFiles: [],
      // 补单相关
      showAddOrderDialog: false,
      addOrderForm: {
        reason: '',
        order: null,
        bomList: [],
        selectedBomList: [],
        searchCode: '',
        searchName: '',
        searchColor: '',
        searchBarCode: '',
        searchMaterialTypeInfo: '',
        searchLength: '',
        searchWidth: '',
        searchHeight: '',
        searchQuantity: '',
        searchRemark: ''
      },
      // 批量付款相关
      showBatchPayDialog: false,
      batchPayForm: {
        contractIds: [],
        contractNo: '',
        custName: '',
        custAddress: '',
        orderNo: '',
        productionOrder: '',
        title: '',
        payReason: '',
        totalAmount: '',
        receivingAccount: '',
        remark: ''
      },
      batchPayFiles: [],
      // 单个付款相关
      showPayDialog: false,
      payForm: {
        orderId: '',
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        remark: '',
        title: '',
        payReason: '',
        totalAmount: '',
        receivingAccount: '',
        productionOrder: ''
      },
      payFiles: [],
      // 单个取消相关
      showCancelDialog: false,
      cancelForm: {
        orderId: '',
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: '',
        applyReason: '',
        remark: '',
        urgentAfterReorder: '',
        title: '',
        productionOrder: ''
      },
      cancelFiles: [],
      // 订单回退相关
      showRollbackDialog: false,
      rollbackForm: {
        orderId: '',
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: '',
        applyReason: '',
        remark: '',
        productionOrder: ''
      },
      rollbackFiles: [],
      // 订单详情相关
      showOrderDetailDialog: false,
      currentOrder: null,
      contractList: [],
      currentPage: 1,
      pageSize: 10,
      total: 4
    };
  },
  methods: (_methods = {
    // 获取状态标签类型
    handleContractSelectionChange: function handleContractSelectionChange(selection) {
      var _this2 = this;

      var currentChecked = selection.map(function (item) {
        return item.contractId;
      });
      var previousChecked = this.checkedContracts.map(function (item) {
        return item.contractId;
      });
      var newlyChecked = currentChecked.filter(function (id) {
        return !previousChecked.includes(id);
      });
      var unchecked = previousChecked.filter(function (id) {
        return !currentChecked.includes(id);
      });

      if (newlyChecked.length > 0) {
        newlyChecked.forEach(function (contractId) {
          var contract = _this2.contractList.find(function (c) {
            return c.contractId === contractId;
          });

          if (contract && contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              if (!_this2.checkedDesignSchemes.some(function (d) {
                return d.id === ds.id;
              })) {
                _this2.checkedDesignSchemes.push(ds);
              }

              if (ds.orderSolutions) {
                ds.orderSolutions.forEach(function (os) {
                  if (!_this2.checkedOrderSolutions.some(function (o) {
                    return o.id === os.id;
                  })) {
                    _this2.checkedOrderSolutions.push(os);
                  }
                });
              }

              _this2.$nextTick(function () {
                var designTable = _this2.$refs['designTable_' + contractId];

                if (designTable) {
                  var table = Array.isArray(designTable) ? designTable[0] : designTable;

                  if (table) {
                    contract.designSchemes.forEach(function (d) {
                      table.toggleRowSelection(d, true);
                    });
                  }
                }

                var solutionTable = _this2.$refs['solutionTable_' + ds._contractId + '_' + ds.id];

                if (solutionTable) {
                  var sTable = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                  if (sTable && ds.orderSolutions) {
                    ds.orderSolutions.forEach(function (o) {
                      sTable.toggleRowSelection(o, true);
                    });
                  }
                }
              });
            });
          }
        });
      }

      if (unchecked.length > 0) {
        unchecked.forEach(function (contractId) {
          var contract = _this2.contractList.find(function (c) {
            return c.contractId === contractId;
          });

          if (contract && contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              _this2.checkedDesignSchemes = _this2.checkedDesignSchemes.filter(function (d) {
                return d.id !== ds.id;
              });

              if (ds.orderSolutions) {
                ds.orderSolutions.forEach(function (os) {
                  _this2.checkedOrderSolutions = _this2.checkedOrderSolutions.filter(function (o) {
                    return o.id !== os.id;
                  });
                });
              }

              _this2.$nextTick(function () {
                var designTable = _this2.$refs['designTable_' + contractId];

                if (designTable) {
                  var table = Array.isArray(designTable) ? designTable[0] : designTable;

                  if (table) {
                    contract.designSchemes.forEach(function (d) {
                      table.toggleRowSelection(d, false);
                    });
                  }
                }

                var solutionTable = _this2.$refs['solutionTable_' + ds._contractId + '_' + ds.id];

                if (solutionTable) {
                  var sTable = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                  if (sTable && ds.orderSolutions) {
                    ds.orderSolutions.forEach(function (o) {
                      sTable.toggleRowSelection(o, false);
                    });
                  }
                }
              });
            });
          }
        });
      }

      this.checkedContracts = selection;
    },
    handleDesignSchemeSelectionChange: function handleDesignSchemeSelectionChange(selection) {
      var _this3 = this;

      var currentChecked = selection.map(function (item) {
        return item.id;
      });
      var previousChecked = this.checkedDesignSchemes.map(function (item) {
        return item.id;
      });
      var newlyChecked = currentChecked.filter(function (id) {
        return !previousChecked.includes(id);
      });
      var unchecked = previousChecked.filter(function (id) {
        return !currentChecked.includes(id);
      });

      if (newlyChecked.length > 0) {
        newlyChecked.forEach(function (dsId) {
          var ds = _this3.contractList.flatMap(function (c) {
            return c.designSchemes || [];
          }).find(function (d) {
            return d.id === dsId;
          });

          if (ds && ds.orderSolutions) {
            ds.orderSolutions.forEach(function (os) {
              if (!_this3.checkedOrderSolutions.some(function (o) {
                return o.id === os.id;
              })) {
                _this3.checkedOrderSolutions.push(os);
              }
            });

            _this3.$nextTick(function () {
              var solutionTable = _this3.$refs['solutionTable_' + ds._contractId + '_' + dsId];

              if (solutionTable) {
                var sTable = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                if (sTable) {
                  ds.orderSolutions.forEach(function (o) {
                    sTable.toggleRowSelection(o, true);
                  });
                }
              }
            });
          }
        });
      }

      if (unchecked.length > 0) {
        unchecked.forEach(function (dsId) {
          var ds = _this3.contractList.flatMap(function (c) {
            return c.designSchemes || [];
          }).find(function (d) {
            return d.id === dsId;
          });

          if (ds && ds.orderSolutions) {
            ds.orderSolutions.forEach(function (os) {
              _this3.checkedOrderSolutions = _this3.checkedOrderSolutions.filter(function (o) {
                return o.id !== os.id;
              });
            });

            _this3.$nextTick(function () {
              var solutionTable = _this3.$refs['solutionTable_' + ds._contractId + '_' + dsId];

              if (solutionTable) {
                var sTable = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                if (sTable) {
                  ds.orderSolutions.forEach(function (o) {
                    sTable.toggleRowSelection(o, false);
                  });
                }
              }
            });
          }
        });
      }

      this.checkedDesignSchemes = selection;
    },
    handleOrderSolutionSelectionChange: function handleOrderSolutionSelectionChange(selection) {
      this.checkedOrderSolutions = selection;
    },
    // 监听屏幕高度变化
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    // 初始化表头配置
    initTableHeader: function initTableHeader() {
      var fields = this.dict.order_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      this.tableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      this.loadHeaderConfig();
    },
    // 加载表头配置
    loadHeaderConfig: function loadHeaderConfig() {
      var _this4 = this;

      if (!this.tableHeader || this.tableHeader.length === 0) return;
      var savedConfig = localStorage.getItem('orderHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this4.tableHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }
          });
          this.tableHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
        } catch (e) {
          console.error('加载表头配置失败:', e);
        }
      }
    },
    // 判断列是否可见
    isColumnVisible: function isColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      return col ? col.visible : true;
    },
    // 切换列显示/隐藏
    toggleColumnVisible: function toggleColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });

      if (col) {
        col.visible = !col.visible;
      }
    },
    // 获取列值
    getColumnValue: function getColumnValue(key, row) {
      if (!row) return '-';
      if (key === 'name') return row[key] ? row[key] : '-';
      if (key === 'mobile') return row[key] || '-';
      if (key === 'address') return row[key] || '-';

      if (key === 'amount') {
        if (this.$parent.checkPer(['admin', 'orders:viewAmount'])) {
          return "\xA5".concat((row[key] || 0).toFixed(2));
        }

        return '***';
      }

      if (key === 'custStatus') {
        return row.custStatus || '未知';
      }

      if (key === 'customerStats') {
        return "\u5408\u540C ".concat(row.contractNum || 0, " \u4E2A, \u8BA2\u5355 ").concat(row.orderNum || 0, " \u4E2A, \u552E\u540E ").concat(row.afterNum || 0, " \u4E2A");
      }

      return row[key] || '-';
    },
    // 获取字符串显示宽度
    getStrWidth: function getStrWidth(str) {
      var width = 0;

      var _iterator = _createForOfIteratorHelper(String(str)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (/[\u4e00-\u9fa5]/.test(char)) {
            width += 24;
          } else if (/[0-9]/.test(char)) {
            width += 10;
          } else {
            width += 10;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return width;
    },
    // 获取列宽度
    getColumnWidth: function getColumnWidth(key) {
      var _this5 = this;

      if (key === 'customerStats') {
        return 300;
      }

      if (!this.contractList || this.contractList.length === 0) {
        return 140;
      }

      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      var headerWidth = this.getStrWidth(col ? col.label : key);
      var values = this.contractList.map(function (row) {
        return _this5.getColumnValue(key, row) || '';
      });
      var dataWidth = Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (v) {
        return _this5.getStrWidth(v);
      })));
      var maxWidth = Math.max(headerWidth, dataWidth);
      var minWidth = 80;
      return Math.max(maxWidth + 20, minWidth);
    },
    // 全部左移（隐藏所有列）
    moveAllToLeft: function moveAllToLeft() {
      this.tableHeader.forEach(function (col) {
        col.visible = false;
      });
    },
    // 全部右移（显示所有列）
    moveAllToRight: function moveAllToRight() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
    },
    // 打开配置弹窗
    openConfigDialog: function openConfigDialog() {
      this.originalHeaderConfig = this.tableHeader.map(function (col, index) {
        return {
          key: col.key,
          visible: col.visible,
          sort: index
        };
      });
      this.configDialogVisible = true;
    },
    // 保存表头配置
    saveHeaderConfig: function () {
      var _saveHeaderConfig = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var config, dictData, updatePromises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.tableHeader.map(function (col, index) {
                  return {
                    key: col.key,
                    visible: col.visible,
                    sort: index
                  };
                });
                localStorage.setItem('orderHeaderConfig', JSON.stringify(config));
                dictData = this.dict.order_display_fields;
                updatePromises = [];
                config.forEach(function (item, index) {
                  var originalItem = _this6.originalHeaderConfig.find(function (o) {
                    return o.key === item.key;
                  });

                  if (originalItem && (originalItem.visible !== item.visible || originalItem.sort !== index)) {
                    var dictItem = dictData.find(function (d) {
                      return d.value === item.key;
                    });

                    if (dictItem && dictItem.id) {
                      updatePromises.push((0, _dictDetail.edit)({
                        id: dictItem.id,
                        dict: {
                          id: dictItem.dict.id
                        },
                        value: dictItem.value,
                        label: dictItem.label,
                        unit: item.visible,
                        dictSort: index
                      }));
                    }
                  }
                });

                if (!(updatePromises.length > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return Promise.all(updatePromises);

              case 9:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this6.handleSearch();
                });
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.error('保存字典配置失败:', _context.t0);
                this.$message.warning('本地保存成功，但服务器保存失败');
                this.$nextTick(function () {
                  _this6.handleSearch();
                });

              case 18:
                _context.next = 22;
                break;

              case 20:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this6.handleSearch();
                });

              case 22:
                this.configDialogVisible = false;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));

      function saveHeaderConfig() {
        return _saveHeaderConfig.apply(this, arguments);
      }

      return saveHeaderConfig;
    }(),
    // 重置表头配置
    resetHeaderConfig: function resetHeaderConfig() {
      var fields = this.dict.order_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      var newTableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      newTableHeader.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.tableHeader = newTableHeader;
    },
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        '待签单': 'warning',
        '已签单': 'success',
        '待分配设计师': 'warning',
        '待测量': 'warning',
        '待复尺': 'warning',
        '待确认设计方案': 'warning',
        '待下单': 'warning',
        '已下单': 'primary',
        '待处理': 'warning',
        '已发货': 'primary',
        '已安装': 'success',
        '已完成': 'success',
        '待审核': 'info',
        '被退回': 'danger',
        '待付款': 'warning',
        '待入库': 'primary',
        '齐套待预约': 'primary',
        '待发货': 'info',
        '不齐套发货': 'warning',
        '售后中': 'danger'
      };
      return statusMap[status] || 'info';
    },
    getStatusClass: function getStatusClass(status) {
      var statusMap = {
        '待处理': 'warning',
        '已发货': 'primary',
        '已安装': 'success',
        '已完成': 'success',
        '待审核': 'info',
        '被退回': 'danger',
        '待付款': 'warning',
        '待入库': 'primary',
        '齐套待预约': 'primary',
        '待发货': 'info',
        '不齐套发货': 'warning',
        '售后中': 'danger'
      };
      return statusMap[status] || 'info';
    },
    toggleDesignScheme: function toggleDesignScheme(id) {
      if (this.collapsedDesignSchemes.includes(id)) {
        this.collapsedDesignSchemes = this.collapsedDesignSchemes.filter(function (dsId) {
          return dsId !== id;
        });
      } else {
        this.collapsedDesignSchemes.push(id);
      }
    },
    isDesignSchemeExpanded: function isDesignSchemeExpanded(id) {
      return !this.collapsedDesignSchemes.includes(id);
    },
    handleContractRowClick: function handleContractRowClick(row, column) {
      if (column && column.type === 'selection') {
        return;
      }

      this.$refs.contractTable.toggleRowExpansion(row);
    },
    handleDesignSchemeRowClick: function handleDesignSchemeRowClick(row, column) {
      if (column && column.type === 'selection') {
        return;
      }

      var contract = this.contractList.find(function (c) {
        return c.designSchemes && c.designSchemes.some(function (ds) {
          return ds.id === row.id;
        });
      });

      if (contract) {
        var table = this.$refs['designTable_' + contract.contractId];

        if (table) {
          var tableInstance = Array.isArray(table) ? table[0] : table;

          if (tableInstance) {
            tableInstance.toggleRowExpansion(row);
          }
        }
      }
    },
    handleContractExpandChange: function handleContractExpandChange(row, expanded) {
      var _this7 = this;

      if (expanded && row.designSchemes) {
        var checkedDsIds = new Set(this.checkedDesignSchemes.map(function (d) {
          return d.id;
        }));
        this.$nextTick(function () {
          var designTable = _this7.$refs['designTable_' + row.contractId];

          if (designTable) {
            var table = Array.isArray(designTable) ? designTable[0] : designTable;

            if (table) {
              row.designSchemes.forEach(function (ds) {
                if (checkedDsIds.has(ds.id)) {
                  table.toggleRowSelection(ds, true);
                }
              });
            }
          }
        });
      }
    },
    handleDesignSchemeExpandChange: function handleDesignSchemeExpandChange(row, expanded) {
      var _this8 = this;

      if (expanded && row.orderSolutions) {
        var checkedSolutionIds = new Set(this.checkedOrderSolutions.map(function (o) {
          return o.id;
        }));
        this.$nextTick(function () {
          var solutionTable = _this8.$refs['solutionTable_' + row._contractId + '_' + row.id];

          if (solutionTable) {
            var table = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

            if (table) {
              row.orderSolutions.forEach(function (os) {
                if (checkedSolutionIds.has(os.id)) {
                  table.toggleRowSelection(os, true);
                }
              });
            }
          }
        });
      }
    },
    handleBatchDelivery: function handleBatchDelivery() {
      var _this9 = this;

      var expandAllDesignSchemes = function expandAllDesignSchemes() {
        return new Promise(function (resolve) {
          _this9.contractList.forEach(function (contract) {
            if (contract.designSchemes && _this9.$refs['designSchemeTable_' + contract.contractId]) {
              var dsTable = _this9.$refs['designSchemeTable_' + contract.contractId];
              var table = Array.isArray(dsTable) ? dsTable[0] : dsTable;

              if (table) {
                contract.designSchemes.forEach(function (ds) {
                  table.toggleRowExpansion(ds, true);
                });
              }
            }
          });

          setTimeout(function () {
            resolve();
          }, 100);
        });
      };

      expandAllDesignSchemes().then(function () {
        var selectedOrderSolutions = [];
        var allSelectedOrderSolutions = [];

        _this9.contractList.forEach(function (contract) {
          if (contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              var solutionTable = _this9.$refs['solutionTable_' + ds._contractId + '_' + ds.id];

              if (solutionTable) {
                var table = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                if (table && table.store && table.store.states) {
                  var selection = table.store.states.selection || [];
                  selection.forEach(function (item) {
                    if (!allSelectedOrderSolutions.some(function (o) {
                      return o.id === item.id;
                    })) {
                      allSelectedOrderSolutions.push(item);
                    }
                  });
                }
              }
            });
          }
        });

        if (allSelectedOrderSolutions.length > 0) {
          selectedOrderSolutions = allSelectedOrderSolutions;
        } else if (_this9.checkedOrderSolutions && _this9.checkedOrderSolutions.length > 0) {
          selectedOrderSolutions = _this9.checkedOrderSolutions;
        }

        if (!selectedOrderSolutions || selectedOrderSolutions.length === 0) {
          _this9.$message.warning('请先选择要发货的订单方案');

          return;
        }

        var selectedSolutionIds = selectedOrderSolutions.map(function (o) {
          return o.id;
        });

        var selectedContractList = _this9.contractList.map(function (contract) {
          var designSchemes = (contract.designSchemes || []).map(function (ds) {
            var orderSolutions = (ds.orderSolutions || []).filter(function (o) {
              return selectedSolutionIds.includes(o.id);
            });
            return orderSolutions.length > 0 ? _objectSpread(_objectSpread({}, ds), {}, {
              orderSolutions: orderSolutions
            }) : null;
          }).filter(Boolean);
          return designSchemes.length > 0 ? _objectSpread(_objectSpread({}, contract), {}, {
            designSchemes: designSchemes
          }) : null;
        }).filter(Boolean);

        sessionStorage.setItem('delivery_contractList', JSON.stringify(selectedContractList));

        _this9.$router.push({
          path: '/cms/delivery/create'
        });
      });
    },
    handleViewOrder: function handleViewOrder(order) {
      // 打开订单详情弹窗
      this.currentOrder = order;
      this.showOrderDetailDialog = true;
    },
    handleDelivery: function handleDelivery(order) {
      this.$router.push({
        path: '/cms/delivery/create',
        query: {
          orderId: order.id,
          productionOrder: order.productionOrder
        }
      });
    },
    handleEditOrder: function handleEditOrder(row) {
      this.$message.info('编辑订单: ' + row.orderNo);
    },
    handleDeleteOrder: function handleDeleteOrder(id) {
      var _this10 = this;

      this.$confirm('确定要删除这个订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.$message.success('删除成功');
      }).catch(function () {
        _this10.$message.info('已取消删除');
      });
    },
    handleSearch: function handleSearch() {
      var _this11 = this;

      this.tableLoading = true;
      var params = {};

      if (this.searchForm.productionStatus) {
        params.productionStatus = this.searchForm.productionStatus;
      }

      if (this.searchForm.custName) {
        params.custName = this.searchForm.custName;
      }

      if (this.searchForm.productionOrder) {
        params.productionOrder = this.searchForm.productionOrder;
      }

      if (this.searchForm.custAddress) {
        params.custAddress = this.searchForm.custAddress;
      }

      if (this.searchForm.contractNo) {
        params.contractNo = this.searchForm.contractNo;
      }

      if (this.searchForm.scheduledDeliveryDate) {
        params.scheduledDeliveryDate = this.searchForm.scheduledDeliveryDate;
      }

      params.size = this.pageSize;
      params.page = this.currentPage - 1; // API使用0-based页码
      //未创建任务的订单方案 null全部, true有, false无

      params.hasOrderSolution = true;
      (0, _installTask.getPendingTree)(params).then(function (response) {
        if (response.code === 200) {
          var rawList = response.data.content || [];
          _this11.contractList = rawList.map(function (contract) {
            return _objectSpread(_objectSpread({}, contract), {}, {
              designSchemes: (contract.designSchemes || []).map(function (ds) {
                return _objectSpread(_objectSpread({}, ds), {}, {
                  _contractId: contract.contractId,
                  _rowKey: "".concat(contract.contractId, "_").concat(ds.id),
                  orderSolutions: (ds.orderSolutions || []).map(function (os) {
                    return _objectSpread(_objectSpread({}, os), {}, {
                      _rowKey: "".concat(contract.contractId, "_").concat(ds.id, "_").concat(os.id)
                    });
                  })
                });
              })
            });
          });
          _this11.total = response.data.totalElements || 0;
          _this11.collapsedDesignSchemes = [];

          _this11.contractList.forEach(function (contract) {
            if (contract.designSchemes) {
              contract.designSchemes.forEach(function (ds) {
                _this11.collapsedDesignSchemes.push(ds.id);
              });
            }
          });
        } else {
          _this11.$message.error(response.msg || '查询失败');
        }
      }).catch(function (error) {
        console.error('查询订单失败:', error);

        _this11.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this11.tableLoading = false;
      });
    },
    handleExport: function handleExport() {
      var _this12 = this;

      var params = {};

      if (this.searchForm.productionStatus) {
        params.productionStatus = this.searchForm.productionStatus;
      }

      if (this.searchForm.custName) {
        params.custName = this.searchForm.custName;
      }

      if (this.searchForm.productionOrder) {
        params.productionOrder = this.searchForm.productionOrder;
      }

      if (this.searchForm.custAddress) {
        params.custAddress = this.searchForm.custAddress;
      }

      if (this.searchForm.contractNo) {
        params.contractNo = this.searchForm.contractNo;
      }

      if (this.searchForm.scheduledDeliveryDate) {
        params.scheduledDeliveryDate = this.searchForm.scheduledDeliveryDate;
      }

      params.hasOrderSolution = true;
      this.exportLoading = true;
      (0, _installTask.exportPendingTree)(params).then(function (res) {
        (0, _index7.downloadFile)(res, '待安装列表', 'xlsx');

        _this12.$message.success('导出成功');
      }).catch(function () {
        _this12.$message.error('导出失败');
      }).finally(function () {
        _this12.exportLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        productionOrder: '',
        custName: '',
        productionStatus: '',
        custAddress: '',
        contractNo: '',
        scheduledDeliveryDate: ''
      };
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.currentPage = current;
      this.handleSearch();
    },
    handleExpandAll: function handleExpandAll() {
      var _this13 = this;

      this.contractList.forEach(function (contract) {
        _this13.$refs.contractTable.toggleRowExpansion(contract, true);
      });
      this.collapsedDesignSchemes = [];
    },
    handleCollapseAll: function handleCollapseAll() {
      var _this14 = this;

      this.contractList.forEach(function (contract) {
        _this14.$refs.contractTable.toggleRowExpansion(contract, false);
      });
      this.collapsedDesignSchemes = this.contractList.flatMap(function (contract) {
        return contract.designSchemes ? contract.designSchemes.map(function (ds) {
          return ds.id;
        }) : [];
      });
    },
    // 合同层级批量操作
    handleContractBatchCommand: function handleContractBatchCommand(command, contract) {
      var contractId = contract.contractId;

      if (!this.checkedContracts.some(function (c) {
        return (c.contractId || c) === contractId;
      })) {
        this.checkedContracts.push(contract);
      }

      switch (command) {
        case 'pay':
          this.handleBatchPay();
          break;

        case 'rollback':
          this.handleBatchRollback();
          break;

        case 'cancel':
          this.handleBatchCancel();
          break;
      }

      var index = this.checkedContracts.findIndex(function (c) {
        return (c.contractId || c) === contractId;
      });

      if (index > -1) {
        this.checkedContracts.splice(index, 1);
      }
    },
    // 批量下单
    handleBatchOrder: function () {
      var _handleBatchOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.checkedContracts.length === 0)) {
                  _context2.next = 3;
                  break;
                }

                this.$message.warning('请先选择要下单的合同');
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return this.$confirm('确认要对选中的合同进行批量下单吗？', '批量下单确认', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });

              case 6:
                _context2.next = 8;
                return (0, _order.batchCreateMesByContractId)(this.checkedContracts.map(function (c) {
                  return c.contractId || c;
                }));

              case 8:
                response = _context2.sent;

                if (response.code === 200) {
                  this.$message.success('批量下单成功');
                  this.handleSearch();
                } else {
                  this.$message.error(response.msg || '批量下单失败');
                }

                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](3);

                if (_context2.t0 !== 'cancel') {
                  console.error('批量下单失败:', _context2.t0);
                  this.$message.error('网络错误，请稍后重试');
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 12]]);
      }));

      function handleBatchOrder() {
        return _handleBatchOrder.apply(this, arguments);
      }

      return handleBatchOrder;
    }(),
    // 批量付款
    handleBatchPay: function handleBatchPay() {
      if (this.checkedContracts.length === 0) {
        this.$message.warning('请先选择要付款的合同');
        return;
      }

      var orderInfos = this.getSelectedOrderInfos().filter(function (o) {
        return o.productionStatus === '待经销商确认';
      });

      if (orderInfos.length === 0) {
        this.$message.warning('所选合同下没有可付款的订单（需为待经销商确认状态）');
        return;
      }

      var orderNos = orderInfos.map(function (o) {
        return o.orderNo;
      }).join('、');
      var contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractNo;
      }))).join('、');
      var contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractId;
      })));
      var firstOrder = orderInfos[0];
      var totalAmount = orderInfos.reduce(function (sum, o) {
        return sum + (o.amount || 0);
      }, 0); // 初始化批量付款表单

      this.batchPayForm = {
        contractIds: contractIds,
        contractNo: contractNos,
        custName: firstOrder.custName || '',
        custAddress: firstOrder.custAddress || '',
        orderNo: orderNos,
        productionOrder: orderNos,
        title: '',
        payReason: '',
        totalAmount: totalAmount,
        receivingAccount: '',
        remark: ''
      }; // 清空之前的附件

      this.batchPayFiles = []; // 清空上传组件

      if (this.$refs.batchPayFileUpload) {
        this.$refs.batchPayFileUpload.clearImgs();
      } // 打开批量付款弹窗


      this.showBatchPayDialog = true;
    },
    // 批量回退
    handleBatchRollback: function () {
      var _handleBatchRollback = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var orderInfos, orderNos, contractNos, contractIds, firstOrder;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.checkedContracts.length === 0)) {
                  _context3.next = 3;
                  break;
                }

                this.$message.warning('请先选择要回退的合同');
                return _context3.abrupt("return");

              case 3:
                orderInfos = this.getSelectedOrderInfos();

                if (!(orderInfos.length === 0)) {
                  _context3.next = 7;
                  break;
                }

                this.$message.warning('所选合同下没有可回退的订单');
                return _context3.abrupt("return");

              case 7:
                orderNos = orderInfos.map(function (o) {
                  return o.orderNo;
                }).join('、');
                contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractNo;
                }))).join('、');
                contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractId;
                })));
                firstOrder = orderInfos[0];
                this.rollbackForm = {
                  orderId: '',
                  orderNo: orderNos,
                  contractId: contractIds,
                  contractNo: contractNos,
                  custName: firstOrder.custName || '',
                  custAddress: firstOrder.custAddress || '',
                  orderDate: firstOrder.orderDate ? firstOrder.orderDate.slice(0, 10) : '',
                  orderApprovalDate: '',
                  plannedDeliveryDate: '',
                  applyDate: new Date().toISOString().slice(0, 10),
                  applyReason: '',
                  remark: '',
                  productionOrder: orderNos,
                  batchOrderIds: orderInfos.map(function (o) {
                    return o.orderId;
                  })
                };
                this.rollbackFiles = [];

                if (this.$refs.rollbackFileUpload) {
                  this.$refs.rollbackFileUpload.clearImgs();
                }

                this.showRollbackDialog = true;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleBatchRollback() {
        return _handleBatchRollback.apply(this, arguments);
      }

      return handleBatchRollback;
    }(),
    // 批量加急
    handleBatchUrgent: function handleBatchUrgent() {
      if (this.checkedContracts.length === 0) {
        this.$message.warning('请先选择要加急的合同');
        return;
      }

      var orderInfos = this.getSelectedOrderInfos();

      if (orderInfos.length === 0) {
        this.$message.warning('所选合同下没有可加急的订单');
        return;
      }

      var orderNos = orderInfos.map(function (o) {
        return o.orderNo;
      }).join('、');
      var contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractNo;
      }))).join('、');
      var contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractId;
      })));
      var firstOrder = orderInfos[0];
      this.urgentApplyForm = {
        orderId: '',
        orderNo: orderNos,
        contractId: contractIds,
        contractNo: contractNos,
        custName: firstOrder.custName || '',
        custAddress: firstOrder.custAddress || '',
        orderDate: firstOrder.orderDate ? firstOrder.orderDate.slice(0, 10) : '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        title: '',
        productionOrder: orderNos,
        batchOrderIds: orderInfos.map(function (o) {
          return o.orderId;
        })
      };
      this.showUrgentApplyDialog = true;
    },
    // 批量取消
    handleBatchCancel: function handleBatchCancel() {
      if (this.checkedContracts.length === 0) {
        this.$message.warning('请先选择要取消的合同');
        return;
      }

      var orderInfos = this.getSelectedOrderInfos();

      if (orderInfos.length === 0) {
        this.$message.warning('所选合同下没有可取消的订单');
        return;
      }

      var orderNos = orderInfos.map(function (o) {
        return o.orderNo;
      }).join('、');
      var contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractNo;
      }))).join('、');
      var contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractId;
      })));
      var firstOrder = orderInfos[0];
      this.cancelForm = {
        orderId: '',
        orderNo: orderNos,
        contractId: contractIds,
        contractNo: contractNos,
        custName: firstOrder.custName || '',
        custAddress: firstOrder.custAddress || '',
        orderDate: firstOrder.orderDate ? firstOrder.orderDate.slice(0, 10) : '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: '',
        urgentAfterReorder: '',
        title: '',
        productionOrder: orderNos,
        batchOrderIds: orderInfos.map(function (o) {
          return o.orderId;
        })
      };
      this.cancelFiles = [];

      if (this.$refs.cancelFileUpload) {
        this.$refs.cancelFileUpload.clearImgs();
      }

      this.showCancelDialog = true;
    },
    getSelectedOrderInfos: function getSelectedOrderInfos() {
      var _this15 = this;

      var orderInfos = [];

      var _iterator2 = _createForOfIteratorHelper(this.contractList),
          _step2;

      try {
        var _loop = function _loop() {
          var contract = _step2.value;

          if (_this15.checkedContracts.some(function (c) {
            return c.contractId === contract.contractId;
          })) {
            if (contract.designSchemes) {
              var _iterator3 = _createForOfIteratorHelper(contract.designSchemes),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var ds = _step3.value;

                  if (ds.orderSolutions) {
                    var _iterator4 = _createForOfIteratorHelper(ds.orderSolutions),
                        _step4;

                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        var os = _step4.value;
                        orderInfos.push({
                          orderId: os.id,
                          orderNo: ds.productionOrder || '',
                          contractId: contract.contractId,
                          contractNo: contract.contractNumber || '',
                          custName: contract.custName || '',
                          custAddress: contract.custAddress || '',
                          orderDate: contract.contractTime || '',
                          amount: contract.amount || 0,
                          productionStatus: contract.status || ''
                        });
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return orderInfos;
    },
    // 单个订单付款
    handlePayOrder: function handlePayOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      }

      var contract = null;

      var _iterator5 = _createForOfIteratorHelper(this.contractList),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var c = _step5.value;

          if (c.designSchemes) {
            var found = c.designSchemes.some(function (ds) {
              return ds.productionOrder === order.productionOrder;
            });

            if (found) {
              contract = c;
              break;
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (!contract || !contract.contractId || !contract.contractNumber) {
        this.$message.error('缺少合同信息');
        return;
      }

      this.payForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.contractId],
        contractNo: contract.contractNumber,
        custName: contract.custName || '',
        custAddress: contract.custAddress || '',
        remark: '',
        title: '',
        payReason: '',
        totalAmount: order.totalPrice || '',
        receivingAccount: '',
        productionOrder: order.productionOrder
      };
      this.payFiles = [];

      if (this.$refs.payFileUpload) {
        this.$refs.payFileUpload.clearImgs();
      }

      this.showPayDialog = true;
    },
    // 单个订单加急
    handleUrgentOrder: function handleUrgentOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      }

      var contract = null;

      var _iterator6 = _createForOfIteratorHelper(this.contractList),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var c = _step6.value;

          if (c.designSchemes) {
            var found = c.designSchemes.some(function (ds) {
              return ds.productionOrder === order.productionOrder;
            });

            if (found) {
              contract = c;
              break;
            }
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      if (!contract || !contract.contractId || !contract.contractNumber) {
        this.$message.error('缺少合同信息');
        return;
      }

      this.urgentApplyForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.contractId],
        contractNo: contract.contractNumber,
        applyType: '加急申请',
        title: '',
        custName: contract.custName || '',
        custAddress: contract.custAddress || '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: ''
      };
      this.urgentApplyFiles = [];

      if (this.$refs.urgentApplyFileUpload) {
        this.$refs.urgentApplyFileUpload.clearImgs();
      }

      this.showUrgentApplyDialog = true;
    },
    // 单个订单取消
    handleCancelOrder: function handleCancelOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      }

      var contract = null;

      var _iterator7 = _createForOfIteratorHelper(this.contractList),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var c = _step7.value;

          if (c.designSchemes) {
            var found = c.designSchemes.some(function (ds) {
              return ds.productionOrder === order.productionOrder;
            });

            if (found) {
              contract = c;
              break;
            }
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      if (!contract || !contract.contractId || !contract.contractNumber) {
        this.$message.error('缺少合同信息');
        return;
      }

      this.cancelForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.contractId],
        contractNo: contract.contractNumber,
        custName: contract.custName || '',
        custAddress: contract.custAddress || '',
        orderDate: order.createTime || '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: '',
        urgentAfterReorder: '',
        title: '',
        productionOrder: order.productionOrder
      };
      this.cancelFiles = [];

      if (this.$refs.cancelFileUpload) {
        this.$refs.cancelFileUpload.clearImgs();
      }

      this.showCancelDialog = true;
    },
    // 保存订单取消
    saveCancel: function saveCancel() {
      var _this16 = this;

      // 表单验证
      if (!this.cancelForm.contractId || !this.cancelForm.contractNo || !this.cancelForm.custName || !this.cancelForm.custAddress || !this.cancelForm.orderDate || !this.cancelForm.applyDate || !this.cancelForm.applyReason || !this.cancelForm.urgentAfterReorder) {
        this.$message.error('请填写必填信息');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.cancelForm.contractId,
        contractNo: this.cancelForm.contractNo,
        custName: this.cancelForm.custName,
        custAddress: this.cancelForm.custAddress,
        orderDate: this.cancelForm.orderDate,
        orderApprovalDate: this.cancelForm.orderApprovalDate,
        plannedDeliveryDate: this.cancelForm.plannedDeliveryDate,
        applyDate: this.cancelForm.applyDate,
        applyReason: this.cancelForm.applyReason,
        remark: this.cancelForm.remark,
        urgentAfterReorder: this.cancelForm.urgentAfterReorder,
        productionOrders: this.cancelForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        })
      }; // 只有当附件不为空时才添加到请求参数中

      if (this.cancelFiles && this.cancelFiles.length > 0) {
        params.files = this.cancelFiles;
      } // 调用取消接口


      (0, _order.afterSales)(params).then(function (response) {
        if (response.code === 200) {
          _this16.$message.success('取消成功');

          _this16.showCancelDialog = false; // 刷新数据

          _this16.handleSearch(); // 清空附件


          _this16.cancelFiles = [];

          if (_this16.$refs.cancelFileUpload) {
            _this16.$refs.cancelFileUpload.clearImgs();
          }
        } else {
          _this16.$message.error(response.msg || '取消失败');
        }
      }).catch(function (error) {
        console.error('取消失败:', error);

        _this16.$message.error('网络错误，请稍后重试');
      });
    },
    // 订单回退
    handleRollbackOrder: function handleRollbackOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      }

      var contract = null;

      var _iterator8 = _createForOfIteratorHelper(this.contractList),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var c = _step8.value;

          if (c.designSchemes) {
            var found = c.designSchemes.some(function (ds) {
              return ds.productionOrder === order.productionOrder;
            });

            if (found) {
              contract = c;
              break;
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      if (!contract || !contract.contractId || !contract.contractNumber) {
        this.$message.error('缺少合同信息');
        return;
      }

      this.rollbackForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.contractId],
        contractNo: contract.contractNumber,
        custName: contract.custName || '',
        custAddress: contract.custAddress || '',
        orderDate: order.createTime ? order.createTime.slice(0, 10) : '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: '',
        productionOrder: order.productionOrder
      };
      this.rollbackFiles = [];

      if (this.$refs.rollbackFileUpload) {
        this.$refs.rollbackFileUpload.clearImgs();
      }

      this.showRollbackDialog = true;
    },
    // 保存订单回退
    saveRollback: function saveRollback() {
      var _this17 = this;

      // 表单验证
      if (!this.rollbackForm.contractId || !this.rollbackForm.contractNo || !this.rollbackForm.custName || !this.rollbackForm.custAddress || !this.rollbackForm.orderDate || !this.rollbackForm.orderApprovalDate || !this.rollbackForm.plannedDeliveryDate || !this.rollbackForm.applyDate || !this.rollbackForm.applyReason || !this.rollbackForm.remark) {
        this.$message.error('请填写必填信息');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.rollbackForm.contractId,
        contractNo: this.rollbackForm.contractNo,
        custName: this.rollbackForm.custName,
        custAddress: this.rollbackForm.custAddress,
        orderDate: this.rollbackForm.orderDate,
        orderApprovalDate: this.rollbackForm.orderApprovalDate,
        plannedDeliveryDate: this.rollbackForm.plannedDeliveryDate,
        applyDate: this.rollbackForm.applyDate,
        applyReason: this.rollbackForm.applyReason,
        remark: this.rollbackForm.remark,
        productionOrders: this.rollbackForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        })
      }; // 只有当附件不为空时才添加到请求参数中

      if (this.rollbackFiles && this.rollbackFiles.length > 0) {
        params.files = this.rollbackFiles;
      } // 调用回退接口


      (0, _order.orderRollback)(params).then(function (response) {
        if (response.code === 200) {
          _this17.$message.success('回退成功');

          _this17.showRollbackDialog = false; // 刷新数据

          _this17.handleSearch(); // 清空附件


          _this17.rollbackFiles = [];

          if (_this17.$refs.rollbackFileUpload) {
            _this17.$refs.rollbackFileUpload.clearImgs();
          }
        } else {
          _this17.$message.error(response.msg || '回退失败');
        }
      }).catch(function (error) {
        console.error('回退失败:', error);

        _this17.$message.error('网络错误，请稍后重试');
      });
    },
    // 回退附件上传成功
    handleRollbackFileUpload: function handleRollbackFileUpload(filePaths) {
      var _this18 = this;

      this.rollbackFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this18.rollbackFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this18.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 回退附件删除成功
    handleRollbackFileDelete: function handleRollbackFileDelete(fileName) {
      this.rollbackFiles = this.rollbackFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 订单改单
    handleModifyOrder: function handleModifyOrder(order) {
      var _this19 = this;

      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      }

      var contract = null;

      var _iterator9 = _createForOfIteratorHelper(this.contractList),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var c = _step9.value;

          if (c.designSchemes) {
            var found = c.designSchemes.some(function (ds) {
              return ds.productionOrder === order.productionOrder;
            });

            if (found) {
              contract = c;
              break;
            }
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      if (!contract || !contract.contractId) {
        this.$message.error('缺少合同信息');
        return;
      }

      this.$confirm('确认进行改单操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _order.addChangeSubcontract)({
          id: contract.contractId,
          remark: order.productionOrder || ''
        }).then(function (response) {
          if (response.code === 200) {
            _this19.$message.success('改单成功');

            var newContract = response.data;

            if (newContract && newContract.id) {
              _this19.$router.push({
                path: '/orders/create',
                query: {
                  contractId: newContract.id,
                  contractNo: newContract.contractNo,
                  contractAmount: newContract.amount || 0
                }
              });
            } else {
              _this19.handleSearch();
            }
          } else {
            _this19.$message.error(response.msg || '改单失败');
          }
        }).catch(function (error) {
          console.error('改单失败:', error);

          _this19.$message.error('网络错误，请稍后重试');
        });
      }).catch(function () {
        _this19.$message.info('已取消改单');
      });
    },
    // 订单补单
    handleAddOrder: function handleAddOrder(order) {
      var _this20 = this;

      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      }

      this.addOrderForm.order = order;
      this.addOrderForm.reason = '';
      this.addOrderForm.bomList = [];
      this.addOrderForm.selectedBomList = [];
      this.addOrderForm.searchCode = '';
      this.addOrderForm.searchName = '';
      this.addOrderForm.searchColor = '';
      this.addOrderForm.searchBarCode = '';
      this.addOrderForm.searchMaterialTypeInfo = '';
      this.addOrderForm.searchLength = '';
      this.addOrderForm.searchWidth = '';
      this.addOrderForm.searchHeight = '';
      this.addOrderForm.searchQuantity = '';
      this.addOrderForm.searchRemark = '';
      this.bomSearchVersion = 0; // 先显示弹窗，再设置加载状态

      this.showAddOrderDialog = true; // 延迟一下，确保弹窗DOM已渲染

      setTimeout(function () {
        _this20.bomTableLoading = true;
        (0, _order.getBomList)(order.productionOrder).then(function (response) {
          if (response && response.code === 200 && Array.isArray(response.data)) {
            _this20.addOrderForm.bomList = response.data;
          } else if (response && Array.isArray(response)) {
            _this20.addOrderForm.bomList = response;
          } else if (response && response.data && Array.isArray(response.data)) {
            _this20.addOrderForm.bomList = response.data;
          }
        }).catch(function (error) {
          console.error('获取BOM数据失败:', error);
        }).finally(function () {
          _this20.bomTableLoading = false;
        });
      }, 100);
    },
    // 确认补单
    confirmAddOrder: function confirmAddOrder() {
      var _this21 = this;

      if (!this.addOrderForm.selectedBomList || this.addOrderForm.selectedBomList.length === 0) {
        this.$message.error('请选择要补单的BOM数据');
        return;
      }

      var auditId = this.addOrderForm.order.rowId;
      var list = this.addOrderForm.selectedBomList.map(function (item) {
        return {
          remark: item.remark || '',
          name: item.name || '',
          barcode: item.barcode || '',
          materialTypeInfo: item.material || '',
          color: item.color || '',
          length: item.length ? parseFloat(item.length) : 0,
          width: item.width ? parseFloat(item.width) : 0,
          height: item.height ? parseFloat(item.height) : 0,
          quantity: item.quantity ? parseInt(item.quantity) : 0,
          typeName: item.typeName || '',
          splitTypeName: item.splitTypeName || '',
          info1: item.info1 || '',
          info2: item.info2 || '',
          info3: item.info3 || '',
          info4: item.info4 || '',
          info5: item.info5 || '',
          info6: item.info6 || '',
          info7: item.info7 || '',
          info8: item.info8 || '',
          info9: item.info9 || '',
          info10: item.info10 || ''
        };
      });
      var data = {
        auditId: auditId,
        list: list
      };
      (0, _order.orderReplenishmentCreate)(data).then(function (response) {
        if (response && response.code === 200) {
          _this21.$message.success('补单成功');

          _this21.handleSearch();

          _this21.showAddOrderDialog = false;
        } else {
          _this21.$message.error(response.msg || '补单失败');
        }
      }).catch(function (error) {
        console.error('补单失败:', error);

        _this21.$message.error('补单失败');
      });
    },
    // 处理BOM表格选择
    handleBomSelectionChange: function handleBomSelectionChange(selection) {
      this.addOrderForm.selectedBomList = selection;
    },
    // 处理BOM表格行点击
    handleBomRowClick: function handleBomRowClick(row) {
      var table = this.$refs.bomTable;
      if (!table) return; // 触发展开/收起

      table.toggleRowExpansion(row);
    },
    // BOM表格搜索
    handleBomSearch: function handleBomSearch() {
      this.bomSearchVersion = Date.now();
    },
    // BOM表格重置搜索
    resetBomSearch: function resetBomSearch() {
      this.addOrderForm.searchCode = '';
      this.addOrderForm.searchName = '';
      this.addOrderForm.searchColor = '';
      this.addOrderForm.searchBarCode = '';
      this.addOrderForm.searchMaterialTypeInfo = '';
      this.addOrderForm.searchLength = '';
      this.addOrderForm.searchWidth = '';
      this.addOrderForm.searchHeight = '';
      this.addOrderForm.searchQuantity = '';
      this.addOrderForm.searchRemark = '';
      this.bomSearchVersion = Date.now();
    },
    // 批发货
    handleBatchShip: function handleBatchShip() {
      this.$message.info('批发货');
    },
    // 批量安装
    handleBatchInstall: function handleBatchInstall() {
      var _this22 = this;

      var expandAllDesignSchemes = function expandAllDesignSchemes() {
        return new Promise(function (resolve) {
          _this22.contractList.forEach(function (contract) {
            if (contract.designSchemes && _this22.$refs['designTable_' + contract.contractId]) {
              var dsTable = _this22.$refs['designTable_' + contract.contractId];
              var table = Array.isArray(dsTable) ? dsTable[0] : dsTable;

              if (table) {
                contract.designSchemes.forEach(function (ds) {
                  table.toggleRowExpansion(ds, true);
                });
              }
            }
          });

          setTimeout(function () {
            resolve();
          }, 100);
        });
      };

      expandAllDesignSchemes().then(function () {
        var selectedOrderSolutions = [];
        var allSelectedOrderSolutions = [];

        _this22.contractList.forEach(function (contract) {
          if (contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              var solutionTable = _this22.$refs['solutionTable_' + ds._contractId + '_' + ds.id];

              if (solutionTable) {
                var table = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                if (table && table.store && table.store.states) {
                  var selection = table.store.states.selection || [];
                  selection.forEach(function (item) {
                    if (!allSelectedOrderSolutions.some(function (o) {
                      return o.id === item.id;
                    })) {
                      allSelectedOrderSolutions.push(item);
                    }
                  });
                }
              }
            });
          }
        });

        if (allSelectedOrderSolutions.length > 0) {
          selectedOrderSolutions = allSelectedOrderSolutions;
        } else if (_this22.checkedOrderSolutions && _this22.checkedOrderSolutions.length > 0) {
          selectedOrderSolutions = _this22.checkedOrderSolutions;
        }

        if (!selectedOrderSolutions || selectedOrderSolutions.length === 0) {
          _this22.$message.warning('请先选择要安装的订单方案');

          return;
        }

        var selectedSolutionIds = selectedOrderSolutions.map(function (o) {
          return o.id;
        });

        var selectedContractList = _this22.contractList.map(function (contract) {
          var designSchemes = (contract.designSchemes || []).map(function (ds) {
            var orderSolutions = (ds.orderSolutions || []).filter(function (o) {
              return selectedSolutionIds.includes(o.id);
            });
            return orderSolutions.length > 0 ? _objectSpread(_objectSpread({}, ds), {}, {
              orderSolutions: orderSolutions
            }) : null;
          }).filter(Boolean);
          return designSchemes.length > 0 ? _objectSpread(_objectSpread({}, contract), {}, {
            designSchemes: designSchemes
          }) : null;
        }).filter(Boolean);

        sessionStorage.setItem('install_contractList', JSON.stringify(selectedContractList));

        _this22.$router.push({
          path: '/cms/install/create'
        });
      });
    },
    // 查看报价
    handleViewQuotation: function handleViewQuotation(contract) {
      var _this23 = this;

      this.currentQuotationContract = contract;
      this.showQuotationDialog = true;
      this.$nextTick(function () {
        if (_this23.$refs.contractQuotationInfo) {
          _this23.$refs.contractQuotationInfo.init();
        }
      });
    },
    // 查看合同详情
    handleViewContract: function handleViewContract(contract) {
      this.currentContract = contract;

      try {
        var imgs = JSON.parse(contract.contractImgs || '[]');
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        this.contractViewImages = imgs.map(function (img) {
          return {
            url: "".concat(imgPreviewPrefix).concat(img.realName),
            name: img.realName
          };
        });
      } catch (e) {
        this.contractViewImages = [];
      }

      try {
        var files = JSON.parse(contract.file || '[]');
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        this.contractViewFiles = files.map(function (file) {
          return {
            url: "".concat(filePreviewPrefix).concat(file.realName),
            name: file.realName
          };
        });
      } catch (e) {
        this.contractViewFiles = [];
      }

      this.activeContractTab = 'design';
      this.showContractViewDialog = true;
    },
    // 预览图片
    previewImage: function previewImage(url) {
      this.previewImageUrl = url;
      this.previewImageVisible = true;
    },
    // 加急
    handleUrgent: function handleUrgent(contract) {
      var selectedDs = this.checkedDesignSchemes.filter(function (ds) {
        return contract.designSchemes && contract.designSchemes.some(function (d) {
          return d.id === ds.id;
        });
      });
      this.urgentApplyForm = {
        title: '',
        custName: contract.custName || '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        custAddress: contract.custAddress || '',
        remark: '',
        contractId: [contract.contractId],
        contractNo: contract.contractNumber,
        orderNo: selectedDs.map(function (ds) {
          return ds.productionOrder;
        }).join('、')
      };
      this.showUrgentApplyDialog = true;
    },
    // 保存加急申请
    saveUrgentApply: function saveUrgentApply() {
      var _this24 = this;

      // 表单验证
      if (!this.urgentApplyForm.custName) {
        this.$message.error('客户名称不能为空');
        return;
      }

      if (!this.urgentApplyForm.applyDate) {
        this.$message.error('申请日期不能为空');
        return;
      }

      if (!this.urgentApplyForm.applyReason) {
        this.$message.error('申请原因不能为空');
        return;
      }

      if (!this.urgentApplyForm.custAddress) {
        this.$message.error('客户地址不能为空');
        return;
      } // 合并 urgentApplyFiles 中的文件与新上传的文件


      var uploadedFiles = []; // 首先添加 urgentApplyFiles 中的文件（已删除的文件不会在这个数组中）

      if (this.urgentApplyFiles && this.urgentApplyFiles.length > 0) {
        this.urgentApplyFiles.forEach(function (file) {
          uploadedFiles.push(file);
        });
      } // 然后添加新上传的文件


      if (this.$refs.urgentApplyFileUpload && this.$refs.urgentApplyFileUpload.filePaths) {
        this.$refs.urgentApplyFileUpload.filePaths.forEach(function (fileStr) {
          try {
            var fileObj = JSON.parse(fileStr); // 检查是否已存在相同的文件，避免重复添加

            var isDuplicate = uploadedFiles.some(function (existingFile) {
              return existingFile.realName === fileObj.realName;
            });

            if (!isDuplicate) {
              uploadedFiles.push(fileObj);
            }
          } catch (error) {
            console.error('解析文件数据失败:', error);
          }
        });
      } // 构建请求参数


      var params = {
        contractIds: this.urgentApplyForm.contractId,
        contractNo: this.urgentApplyForm.contractNo,
        applyType: '加急申请',
        applyDate: this.urgentApplyForm.applyDate,
        applyReason: this.urgentApplyForm.applyReason,
        custName: this.urgentApplyForm.custName,
        remark: this.urgentApplyForm.remark,
        custAddress: this.urgentApplyForm.custAddress,
        productionOrders: this.urgentApplyForm.orderNo.split('、').map(function (order) {
          return order.trim();
        })
      }; // 只有当附件不为空时才添加files参数

      if (uploadedFiles.length > 0) {
        params.files = uploadedFiles;
      } // 调用保存加急申请的接口


      (0, _contract2.addContractUrgentApply)(params).then(function (response) {
        if (response.code === 200) {
          // 提交成功后关闭弹窗
          _this24.$message.success('加急申请提交成功');

          _this24.showUrgentApplyDialog = false; // 刷新数据

          _this24.handleSearch(); // 更新合同的加急状态


          var contractIds = _this24.urgentApplyForm.contractId || [];

          _this24.contractList.forEach(function (contract) {
            if (contractIds.includes(contract.contractId)) {
              contract.isUrgent = true;
            }
          }); // 重置表单


          _this24.urgentApplyForm = {
            custName: '',
            applyDate: '',
            applyReason: '',
            custAddress: '',
            remark: ''
          };
          _this24.urgentApplyFiles = []; // 清空附件上传组件的文件列表

          if (_this24.$refs.urgentApplyFileUpload) {
            _this24.$refs.urgentApplyFileUpload.clearImgs();
          }
        } else {
          _this24.$message.error(response.msg || '加急申请提交失败');
        }
      }).catch(function (error) {
        console.error('加急申请提交失败:', error);

        _this24.$message.error('网络错误，请重试');
      });
    },
    // 处理附件上传成功
    handleFileUpload: function handleFileUpload(filePaths) {
      var _this25 = this;

      this.urgentApplyFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 检查图片格式是否为jpg或png

          if (fileObj.type === '图片') {
            var fileName = fileObj.realName.toLowerCase();

            if (!fileName.endsWith('.jpg') && !fileName.endsWith('.png')) {
              _this25.$message.error('图片只能上传jpg和png格式');

              return;
            }
          } // 直接将接口返回的数据包添加到 urgentApplyFiles 中


          _this25.urgentApplyFiles.push(fileObj);
        } catch (error) {
          console.error('解析文件数据失败:', error);
        }
      });
    },
    // 处理附件删除成功
    handleFileDelete: function handleFileDelete(fileName) {
      this.urgentApplyFiles = this.urgentApplyFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 处理批量付款附件上传成功
    handleBatchPayFileUpload: function handleBatchPayFileUpload(filePaths) {
      var _this26 = this;

      this.batchPayFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 检查图片格式是否为jpg或png

          if (fileObj.type === '图片') {
            var fileName = fileObj.realName.toLowerCase();

            if (!fileName.endsWith('.jpg') && !fileName.endsWith('.png')) {
              _this26.$message.error('图片只能上传jpg和png格式');

              return;
            }
          } // 检查是否已存在相同的文件，避免重复添加


          var isDuplicate = _this26.batchPayFiles.some(function (existingFile) {
            return existingFile.realName === fileObj.realName;
          });

          if (!isDuplicate) {
            _this26.batchPayFiles.push(fileObj);
          }
        } catch (error) {
          console.error('解析文件数据失败:', error);

          _this26.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 处理批量付款附件删除成功
    handleBatchPayFileDelete: function handleBatchPayFileDelete(fileName) {
      this.batchPayFiles = this.batchPayFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 处理单个付款附件上传成功
    handlePayFileUpload: function handlePayFileUpload(filePaths) {
      var _this27 = this;

      this.payFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this27.payFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this27.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 处理单个付款附件删除成功
    handlePayFileDelete: function handlePayFileDelete(fileName) {
      this.payFiles = this.payFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 处理单个取消附件上传成功
    handleCancelFileUpload: function handleCancelFileUpload(filePaths) {
      var _this28 = this;

      this.cancelFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this28.cancelFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this28.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 处理单个取消附件删除成功
    handleCancelFileDelete: function handleCancelFileDelete(fileName) {
      this.cancelFiles = this.cancelFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 保存批量付款
    saveBatchPay: function saveBatchPay() {
      var _this29 = this;

      // 表单验证
      if (!this.batchPayForm.payReason) {
        this.$message.error('付款事由不能为空');
        return;
      }

      if (!this.batchPayForm.totalAmount) {
        this.$message.error('总金额不能为空');
        return;
      }

      if (!this.batchPayForm.receivingAccount) {
        this.$message.error('收款账户不能为空');
        return;
      }

      if (this.batchPayFiles.length === 0) {
        this.$message.error('请上传付款附件');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.batchPayForm.contractIds,
        contractNo: this.batchPayForm.contractNo,
        productionOrders: this.batchPayForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        }),
        payReason: this.batchPayForm.payReason,
        totalAmount: this.batchPayForm.totalAmount,
        receivingAccount: this.batchPayForm.receivingAccount,
        remark: this.batchPayForm.remark,
        files: this.batchPayFiles
      }; // 调用批量付款接口

      (0, _order.batchPaySales)(params).then(function (response) {
        if (response.code === 200) {
          _this29.$message.success('批量付款成功');

          _this29.showBatchPayDialog = false; // 刷新数据

          _this29.handleSearch(); // 清空选中


          _this29.checkedContracts = []; // 清空附件

          _this29.batchPayFiles = []; // 清空上传组件

          if (_this29.$refs.batchPayFileUpload) {
            _this29.$refs.batchPayFileUpload.clearImgs();
          }
        } else {
          _this29.$message.error(response.msg || '批量付款失败');
        }
      }).catch(function (error) {
        console.error('批量付款失败:', error);
      });
    },
    // 保存单个订单付款
    savePay: function savePay() {
      var _this30 = this;

      // 表单验证
      if (!this.payForm.contractId) {
        this.$message.error('合同信息不能为空');
        return;
      }

      if (!this.payForm.contractNo) {
        this.$message.error('合同号不能为空');
        return;
      }

      if (!this.payForm.payReason) {
        this.$message.error('付款事由不能为空');
        return;
      }

      if (!this.payForm.totalAmount) {
        this.$message.error('总金额不能为空');
        return;
      }

      if (!this.payForm.receivingAccount) {
        this.$message.error('收款账户不能为空');
        return;
      }

      if (!this.payForm.productionOrder) {
        this.$message.error('销售单号不能为空');
        return;
      }

      if (this.payFiles.length === 0) {
        this.$message.error('请上传付款附件');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.payForm.contractId,
        contractNo: this.payForm.contractNo,
        remark: this.payForm.remark,
        productionOrders: this.payForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        }),
        payReason: this.payForm.payReason,
        totalAmount: this.payForm.totalAmount,
        receivingAccount: this.payForm.receivingAccount
      }; // 只有当附件不为空时才添加到请求参数中

      if (this.payFiles && this.payFiles.length > 0) {
        params.files = this.payFiles;
      } // 调用付款接口


      (0, _order.paySales)(params).then(function (response) {
        if (response.code === 200) {
          _this30.$message.success('付款成功');

          _this30.showPayDialog = false; // 刷新数据

          _this30.handleSearch(); // 清空附件


          _this30.payFiles = []; // 清空上传组件

          if (_this30.$refs.payFileUpload) {
            _this30.$refs.payFileUpload.clearImgs();
          }
        } else {
          _this30.$message.error(response.msg || '付款失败');
        }
      }).catch(function (error) {
        console.error('付款失败:', error);

        _this30.$message.error('网络错误，请稍后重试');
      });
    },
    // 获取客户状态样式
    getCustomerStatusClass: function getCustomerStatusClass(status) {
      var statusMap = {
        '跟进中': 'el-tag--warning el-tag--mini el-tag--light',
        '已签单': 'el-tag--primary el-tag--mini el-tag--light',
        '已下单': 'el-tag--success el-tag--mini el-tag--light',
        '未下单': 'el-tag--info el-tag--mini el-tag--light',
        '待处理': 'el-tag--warning el-tag--mini el-tag--light',
        '已发货': 'el-tag--primary el-tag--mini el-tag--light',
        '已安装': 'el-tag--success el-tag--mini el-tag--light',
        '已完成': 'el-tag--success el-tag--mini el-tag--light',
        '售后中': 'el-tag--danger el-tag--mini el-tag--light'
      };
      return statusMap[status] || 'el-tag--info el-tag--mini el-tag--light';
    },
    handleAllCheck: function handleAllCheck(checked) {
      var _this31 = this;

      this.allChecked = checked;
      this.checkedContracts = [];
      this.checkedDesignSchemes = [];
      this.checkedOrderSolutions = [];

      if (checked) {
        this.contractList.forEach(function (contract) {
          _this31.checkedContracts.push(contract);

          if (contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              _this31.checkedDesignSchemes.push(ds);

              if (ds.orderSolutions) {
                ds.orderSolutions.forEach(function (os) {
                  _this31.checkedOrderSolutions.push(os);
                });
              }
            });
          }
        });
      }
    },
    handleCustomerCheck: function handleCustomerCheck(customerId, checked) {
      var _this32 = this;

      var contract = this.contractList.find(function (c) {
        return c.custId === customerId;
      });

      if (checked) {
        if (contract && !this.checkedContracts.some(function (c) {
          return c.contractId === contract.contractId;
        })) {
          this.checkedContracts.push(contract);
        }

        if (contract && contract.designSchemes) {
          contract.designSchemes.forEach(function (ds) {
            if (!_this32.checkedDesignSchemes.some(function (d) {
              return d.id === ds.id;
            })) {
              _this32.checkedDesignSchemes.push(ds);
            }

            if (ds.orderSolutions) {
              ds.orderSolutions.forEach(function (os) {
                if (!_this32.checkedOrderSolutions.some(function (o) {
                  return o.id === os.id;
                })) {
                  _this32.checkedOrderSolutions.push(os);
                }
              });
            }
          });
        }
      } else {
        this.checkedContracts = this.checkedContracts.filter(function (c) {
          return c.custId !== customerId;
        });

        if (contract && contract.designSchemes) {
          contract.designSchemes.forEach(function (ds) {
            _this32.checkedDesignSchemes = _this32.checkedDesignSchemes.filter(function (d) {
              return d.id !== ds.id;
            });

            if (ds.orderSolutions) {
              ds.orderSolutions.forEach(function (os) {
                _this32.checkedOrderSolutions = _this32.checkedOrderSolutions.filter(function (o) {
                  return o.id !== os.id;
                });
              });
            }
          });
        }
      }

      this.updateAllChecked();
    },
    handleContractCheck: function handleContractCheck(contractId, checked) {
      var _this33 = this;

      if (checked) {
        var contract = this.contractList.find(function (c) {
          return c.contractId === contractId;
        });

        if (contract && !this.checkedContracts.some(function (c) {
          return c.contractId === contractId;
        })) {
          this.checkedContracts.push(contract);
        }

        if (contract && contract.designSchemes) {
          contract.designSchemes.forEach(function (ds) {
            if (!_this33.checkedDesignSchemes.some(function (d) {
              return d.id === ds.id;
            })) {
              _this33.checkedDesignSchemes.push(ds);
            }

            if (ds.orderSolutions) {
              ds.orderSolutions.forEach(function (os) {
                if (!_this33.checkedOrderSolutions.some(function (o) {
                  return o.id === os.id;
                })) {
                  _this33.checkedOrderSolutions.push(os);
                }
              });
            }
          });
        }
      } else {
        this.checkedContracts = this.checkedContracts.filter(function (c) {
          return c.contractId !== contractId;
        });

        var _contract = this.contractList.find(function (c) {
          return c.contractId === contractId;
        });

        if (_contract && _contract.designSchemes) {
          _contract.designSchemes.forEach(function (ds) {
            _this33.checkedDesignSchemes = _this33.checkedDesignSchemes.filter(function (d) {
              return d.id !== ds.id;
            });

            if (ds.orderSolutions) {
              ds.orderSolutions.forEach(function (os) {
                _this33.checkedOrderSolutions = _this33.checkedOrderSolutions.filter(function (o) {
                  return o.id !== os.id;
                });
              });
            }
          });
        }
      }

      this.updateAllChecked();
    },
    updateAllChecked: function updateAllChecked() {
      var totalContracts = this.contractList.length;
      var checkedContractsCount = this.checkedContracts.length;
      var totalDs = 0;
      var checkedDsCount = this.checkedDesignSchemes.length;
      var totalSolutions = 0;
      var checkedSolutionsCount = this.checkedOrderSolutions.length;
      this.contractList.forEach(function (contract) {
        if (contract.designSchemes) {
          totalDs += contract.designSchemes.length;
          contract.designSchemes.forEach(function (ds) {
            if (ds.orderSolutions) {
              totalSolutions += ds.orderSolutions.length;
            }
          });
        }
      });
      this.allChecked = checkedContractsCount === totalContracts && checkedDsCount === totalDs && checkedSolutionsCount === totalSolutions;
    },
    handleOrderCheck: function handleOrderCheck(solutionId, checked) {
      if (checked) {
        if (!this.checkedOrderSolutions.some(function (o) {
          return o.id === solutionId;
        })) {
          this.checkedOrderSolutions.push(solutionId);
        }
      } else {
        this.checkedOrderSolutions = this.checkedOrderSolutions.filter(function (o) {
          return o.id !== solutionId;
        });
      }

      this.updateAllChecked();
    },
    handleContractOrderCheck: function handleContractOrderCheck(contractId, checked) {
      var _this34 = this;

      var contract = this.contractList.find(function (c) {
        return c.contractId === contractId;
      });

      if (contract && contract.designSchemes) {
        contract.designSchemes.forEach(function (ds) {
          if (ds.orderSolutions) {
            ds.orderSolutions.forEach(function (os) {
              if (checked) {
                if (!_this34.checkedOrderSolutions.some(function (o) {
                  return o.id === os.id;
                })) {
                  _this34.checkedOrderSolutions.push(os);
                }
              } else {
                _this34.checkedOrderSolutions = _this34.checkedOrderSolutions.filter(function (o) {
                  return o.id !== os.id;
                });
              }
            });
          }
        });
      }

      this.updateAllChecked();
    }
  }, (0, _defineProperty2.default)(_methods, "handleOrderCheck", function handleOrderCheck(solutionId, checked) {
    if (checked) {
      if (!this.checkedOrderSolutions.some(function (o) {
        return o.id === solutionId;
      })) {
        this.checkedOrderSolutions.push(solutionId);
      }
    } else {
      this.checkedOrderSolutions = this.checkedOrderSolutions.filter(function (o) {
        return o.id !== solutionId;
      });
    }

    this.updateAllChecked();
  }), (0, _defineProperty2.default)(_methods, "getOrderSolutionCount", function getOrderSolutionCount(row) {
    if (!row.designSchemes || row.designSchemes.length === 0) return 0;
    return row.designSchemes.reduce(function (sum, ds) {
      return sum + (ds.orderSolutions ? ds.orderSolutions.length : 0);
    }, 0);
  }), (0, _defineProperty2.default)(_methods, "getDesignSchemeTotalPackages", function getDesignSchemeTotalPackages(ds) {
    if (!ds.orderSolutions || ds.orderSolutions.length === 0) return 0;
    return ds.orderSolutions.reduce(function (sum, os) {
      return sum + (os.packages || 0);
    }, 0);
  }), (0, _defineProperty2.default)(_methods, "getContractTotalPackages", function getContractTotalPackages(row) {
    var _this35 = this;

    if (!row.designSchemes || row.designSchemes.length === 0) return 0;
    return row.designSchemes.reduce(function (sum, ds) {
      return sum + _this35.getDesignSchemeTotalPackages(ds);
    }, 0);
  }), (0, _defineProperty2.default)(_methods, "getContractTotalArea", function getContractTotalArea(row) {
    if (!row.designSchemes || row.designSchemes.length === 0) return 0;
    return row.designSchemes.reduce(function (sum, ds) {
      if (!ds.orderSolutions || ds.orderSolutions.length === 0) return sum;
      return sum + ds.orderSolutions.reduce(function (s, os) {
        return s + (parseFloat(os.area) || 0);
      }, 0);
    }, 0);
  }), (0, _defineProperty2.default)(_methods, "handleCreateOrder", function handleCreateOrder(contract) {
    this.$router.push({
      path: '/orders/create',
      query: {
        contractId: contract.contractId,
        contractNo: contract.contractNumber,
        contractAmount: contract.amount
      }
    });
  }), (0, _defineProperty2.default)(_methods, "getContractStatusClass", function getContractStatusClass(status) {
    var statusMap = {
      '进行中': 'el-tag--primary el-tag--mini el-tag--light',
      '已完成': 'el-tag--success el-tag--mini el-tag--light',
      '售后中': 'el-tag--warning el-tag--mini el-tag--light',
      '已关闭': 'el-tag--info el-tag--mini el-tag--light',
      '待签单': 'el-tag--warning el-tag--mini el-tag--light',
      '待下单': 'el-tag--warning el-tag--mini el-tag--light'
    };
    return statusMap[status] || 'el-tag--warning el-tag--mini el-tag--light';
  }), (0, _defineProperty2.default)(_methods, "getTagType", function getTagType(label) {
    var typeMap = {
      '待审核': 'info',
      '被退回': 'danger',
      '待付款': 'warning',
      '待入库': 'success',
      '齐套待预约': 'primary',
      '待发货': 'info',
      '不齐套发货': 'warning',
      '售后中': 'danger'
    };
    return typeMap[label] || 'primary';
  }), (0, _defineProperty2.default)(_methods, "handleReserveDateChange", function handleReserveDateChange(contract) {
    var _this36 = this;

    if (!contract.scheduledDeliveryDate) {
      return;
    }

    var dateStr = this.formatDate(contract.scheduledDeliveryDate);
    this.$confirm("\u786E\u8BA4\u5C06\u5408\u540C ".concat(contract.contractNumber, " \u7684\u9884\u7EA6\u53D1\u8D27\u65F6\u95F4\u8BBE\u7F6E\u4E3A ").concat(dateStr, "\uFF1F"), '确认预约发货', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      var loading = _this36.$loading({
        lock: true,
        text: '预约中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      var data = {
        contractNo: contract.contractNumber,
        scheduledDeliveryDate: dateStr
      };
      (0, _send.reserveSend)(data).then(function (response) {
        loading.close();

        if (response.code === 200) {
          _this36.$message.success(response.message || '预约发货时间确认成功');
        } else {
          contract.scheduledDeliveryDate = null;

          _this36.$message.error(response.msg || '操作失败');
        }
      }).catch(function (error) {
        loading.close();
        contract.scheduledDeliveryDate = null;
        console.error('预约发货时间确认失败:', error);

        _this36.$message.error('网络错误，请稍后重试');
      });
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "handleReserveInstallDateChange", function handleReserveInstallDateChange(contract) {
    var _this37 = this;

    if (!contract.reserveInstallDate) {
      return;
    }

    var dateStr = this.formatDate(contract.reserveInstallDate);
    this.$confirm("\u786E\u8BA4\u5C06\u5408\u540C ".concat(contract.contractNumber, " \u7684\u9884\u7EA6\u5B89\u88C5\u65F6\u95F4\u8BBE\u7F6E\u4E3A ").concat(dateStr, "\uFF1F"), '确认预约安装', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      var loading = _this37.$loading({
        lock: true,
        text: '预约中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      var data = {
        contractNo: contract.contractNumber,
        reserveInstallDate: dateStr
      };
      (0, _installTask.reserveInstallTask)(data).then(function (response) {
        loading.close();

        if (response.code === 200) {
          _this37.$message.success(response.message || '预约安装时间确认成功');
        } else {
          contract.reserveInstallDate = null;

          _this37.$message.error(response.msg || '操作失败');
        }
      }).catch(function (error) {
        loading.close();
        contract.reserveInstallDate = null;
        console.error('预约安装时间确认失败:', error);

        _this37.$message.error('网络错误，请稍后重试');
      });
    }).catch(function () {});
  }), (0, _defineProperty2.default)(_methods, "formatDate", function formatDate(date) {
    if (!date) return '';
    var d = new Date(date);
    var year = d.getFullYear();
    var month = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
  }), _methods)
};
exports.default = _default;